import { connect } from 'react-redux';
import User from './User';
import { selectLegacyLocation } from '../../store/routingCompatSlice';


const mapStateToProps = (state) => {
    const u = state.user || {};
    const pub = u.publisher || {};
    const acc = pub.account || {};
    const bal = acc.balance || {};

    return {
        name: pub.name || u.name || '',
        email: u.email || '',
        timezone: u.timezone || '',
        balanceAmount: typeof bal.amount === 'number' ? bal.amount : 0,
        currencyBalance: bal.currency || 'USD',
        holdBalance: acc.hold_balance ?? 0,
        payoutBalance: acc.payout_balance ?? 0,
        location: selectLegacyLocation(state), // <- legacy-friendly location prop
    };
};

export default connect(mapStateToProps)(User);
